import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { Countdown } from '../countdown';
import TrustBox from '../redesign/TrustBox/TrustBox';
import logo from '../../assets/images/redesign-v2/rafflehouse-logo.svg';
import './Header.scss';
import MobileHeaderCountdown from '../mobile-header-countdown';
import Button from '../common/Button';
import useIsLoggedIn from '../../hooks/useIsLoggedIn';
import Loader from '../Loader/Loader';

const ProfileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z"
      stroke="#043B3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Header = (props) => {
  const [isHidden, setIsHidden] = useState(false);
  const headerRef = useRef();
  const prev = useRef(0);
  const isLoggedIn = useIsLoggedIn();
  const { user } = props;
  const baseUrl = process.env.REACT_APP_BASE_URL || '';
  let classHide = isHidden ? 'hide' : '';
  const hideHeader = (e) => {
    if (window.scrollY > headerRef.current.offsetHeight) {
      window.scrollY > prev.current ? setIsHidden(true) : setIsHidden(false);
    } else {
      setIsHidden(false);
    }
    prev.current = window.scrollY;
  };
  const renderCountdown = ({ isTop } = {}) => {
    let stepperCountdown = null;
    if (props.raffle != null) {
      if (props.raffle.stepperCountdown) {
        stepperCountdown = props.raffle.stepperCountdown;
      }
    }

    if (
      stepperCountdown != null &&
      stepperCountdown.isActive &&
      dayjs().isBefore(dayjs(stepperCountdown.endsAt))
    ) {
      if (isTop) {
        let value = stepperCountdown.title;
        return (
          <div className="header__top">
            <MobileHeaderCountdown
              prizeType="not-raffle"
              endsAt={stepperCountdown.endsAt}
              text={value}
            />
            <div className="header-countdown-block">
              {/* <h3>{stepperCountdown.title}</h3>
              <span className='header-countdown-block__devider'>:</span> */}
              <div>
                {/* <Countdown
                  isHeader
                  prizeType='not-raffle'
                  endsAt={stepperCountdown.endsAt}
                /> */}
              </div>
            </div>
          </div>
        );
      }
      return (
        <div className="header-countdown-block">
          <h3>{stepperCountdown.title}</h3>
          <span className="header-countdown-block__devider">:&nbsp;</span>
          <div>
            <Countdown
              isHeader
              prizeType="not-raffle"
              endsAt={stepperCountdown.endsAt}
            />
          </div>
        </div>
      );
    }
  };
  useEffect(() => {
    if (typeof window == 'object') {
      window.addEventListener('scroll', hideHeader);
    }
    return () => {
      if (typeof window == 'object') {
        window.removeEventListener('scroll', hideHeader);
      }
    };
  }, []);
  return (
    <header className={`header ${classHide}`} ref={headerRef}>
      <div className="header__grid">
        <div className="header__left">
          {renderCountdown()}
          {!isLoggedIn && (
            <Button
              as="external-link"
              href={`${baseUrl}/sign-in?from=deal`}
              variant="outline"
              size="sm"
              className="header__button header__button--signin-mobile"
            >
              Sign in
            </Button>
          )}
        </div>
        <a href={baseUrl} className="header__logo">
          <img src={logo} alt="raffle-house-logo" />
        </a>
        <nav className="header__nav">
          <div className="header__auth">
            {isLoggedIn ? (
              <Button
                as="external-link"
                href={`${baseUrl}/profile`}
                variant="outline"
                size="sm"
                className="header__button header__button--profile"
                leftIcon={<ProfileIcon />}
              >
                Welcome, {user?.name ?? <Loader />}
              </Button>
            ) : (
              <>
                <Button
                  as="external-link"
                  href={`${baseUrl}/sign-in?from=deal`}
                  variant="outline"
                  size="sm"
                  className="header__button header__button--signin-desktop"
                >
                  Sign in
                </Button>
                <Button
                  as="external-link"
                  href={`${baseUrl}/sign-up?from=deal`}
                  variant="secondary"
                  size="sm"
                  className="header__button"
                >
                  Sign up
                </Button>
              </>
            )}
          </div>
        </nav>
      </div>
      <div className="header-trustpilot">
        <div className="trust-wrapper">
          <TrustBox isHeader />
        </div>
      </div>
    </header>
  );
};

export default Header;
